const Annotation = () => {
    return (
        <svg enableBackground="new 0 0 20 20" viewBox="0 0 32 32" width="32" height="32" xmlns="http://www.w3.org/2000/svg">
            <path clipRule="evenodd" d="M 15.056,21.456001 27.295999,9.2160003 22.768,4.6880004 10.527999,16.928 Z M 31.055999,5.4560003 C 31.648,4.8800003 32,4.0800004 32,3.2000003 32,1.44 30.559999,0 28.799999,0 c -0.88,0 -1.68,0.352 -2.256,0.944 L 23.904,3.5840004 28.431999,8.1120003 Z M 28.799999,28.8 H 3.2 V 3.2000003 H 17.488 L 20.688,0 H 1.5999999 C 0.71999999,0 0,0.72 0,1.6 V 30.4 C 0,31.28 0.71999999,32 1.5999999,32 H 30.4 C 31.279999,32 32,31.28 32,30.4 V 11.312 l -3.200001,3.2 z M 6.3999998,25.6 13.455999,23.056001 8.9599999,18.592 Z" fillRule="evenodd" fill="currentColor" style={{strokeWidth:1.6}} />
        </svg>
    );
  };
  
  export default Annotation;
  